// extracted by mini-css-extract-plugin
export var columnList = "_el-0";